<template>
  <div>
    {{ multiEntryOption.value }}
    <!-- <root-element
      :rootElement="multiEntryOption"
      :entryItems="entryItems"
      @updated="updated($event)"
    /> -->
  </div>
</template>

<script>
export default {
  name: "MultiEntryOption",
  props: ["entryItems", "multiEntryOption"],
  methods: {
    updated(event) {
      this.$emit("updated", event);
      // console.log(event)
    }
  }
};
</script>